// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SME1rvp6B0AqarZ9yrKv{justify-content:flex-start;align-items:center;padding:0 44px;display:flex;overflow:auto}.BCmEjMwKO0YXcb6yKJDp{width:100%;max-width:760px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `SME1rvp6B0AqarZ9yrKv`,
	"wrap": `BCmEjMwKO0YXcb6yKJDp`
};
export default ___CSS_LOADER_EXPORT___;
